import { render, staticRenderFns } from "./SearchOPD.vue?vue&type=template&id=4f203843&scoped=true"
import script from "./SearchOPD.vue?vue&type=script&lang=js"
export * from "./SearchOPD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f203843",
  null
  
)

export default component.exports